function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
// -------------------------------------
// Dependencies
// -------------------------------------

// Helpers
import { cart } from 'scripts/helpers/iamota-shopify-ajax';
import iamotaEventHandler from 'scripts/helpers/iamota-event-handler';
import translate from 'scripts/helpers/iamota-translate';
import Handlebars from 'handlebars';
import Debug from 'scripts/libs/debug';
import { Loadable } from 'scripts/classes/iamota-component-helpers';
class iamCartUndoItem extends HTMLElement {
  constructor(cachedCartItem) {
    super();
    this.cartItem = cachedCartItem;
    this.loadable = new Loadable(this);
    this.translations = {
      undo: translate('Undo', 'undo.undo_button'),
      undoing: translate('Undoing...', 'undo.undoing'),
      dismiss: translate('Dismiss', 'undo.dismiss_text'),
      // No translation needed for the close button
      // TODO: Create file for handling icons with Handlebars
      dismissCTA: '<svg class="icon icon__close " aria-hidden="true" focusable="false"><use xlink:href="#icon-close"></use></svg>'
    };
  }
  connectedCallback() {
    this.render();
  }
  render() {
    // Abort if the cartItem got nuked before we could use it
    if (!this.cartItem) {
      Debug.extreme('Cart Undo: Item was removed before we could use it', this.cartItem);
      this.remove();
    }
    var translatedMessage = translate('Removed {{ item_title_link }} from the cart.', 'undo.removed_from_cart', _objectSpread(_objectSpread({}, this.cartItem), {}, {
      item_title_link: () => {
        var _this$cartItem, _this$cartItem2;
        if ((_this$cartItem = this.cartItem) !== null && _this$cartItem !== void 0 && (_this$cartItem = _this$cartItem.itemData) !== null && _this$cartItem !== void 0 && _this$cartItem.url && (_this$cartItem2 = this.cartItem) !== null && _this$cartItem2 !== void 0 && (_this$cartItem2 = _this$cartItem2.itemData) !== null && _this$cartItem2 !== void 0 && _this$cartItem2.title) {
          var itemTitle = this.cartItem.itemData.title.replace(/\s*-\s*default variant\s*$/i, '');
          return new Handlebars.SafeString("<a href=\"".concat(this.cartItem.itemData.url, "\" class=\"cart-undo__item-link\">").concat(itemTitle, "</a>"));
        } else {
          console.log('No URL or title found for item', this.cartItem);
          return 'item';
        }
      }
    }));
    this.innerHTML = "\n            <span class=\"cart-undo__message\">".concat(translatedMessage, "</span>\n            <button class=\"cart-undo__cta\">").concat(this.translations.undo, "</button>\n            <button class=\"cart-undo__dismiss\" aria-label=\"").concat(this.translations.dismiss, "\">").concat(this.translations.dismissCTA, "</button>\n        ");
    this.querySelector('.cart-undo__cta').addEventListener('click', this.onUndo.bind(this));
    this.querySelector('.cart-undo__dismiss').addEventListener('click', this.onDismiss.bind(this));
  }
  onUndo(event) {
    var _this = this;
    return _asyncToGenerator(function* () {
      event.preventDefault();
      _this.setLoading(true);
      _this.querySelector('.cart-undo__cta').innerHTML = _this.translations.undoing;
      var item = _this.cartItem.itemData;
      iamotaEventHandler.trigger('cartForm:items:item:undo:undoing', {
        item
      }, {
        context: _this
      });
      cart.addItem(item).then(cart => {
        iamotaEventHandler.trigger('cartForm:items:item:undo:undone', {
          cart,
          item
        }, {
          context: _this
        });
        _this.remove(); // Remove self from the DOM
      }).catch(error => {
        // TODO: handle the error more gracefully
        _this.querySelector('.cart-undo__message').innerHTML = error.message;
        _this.querySelector('.cart-undo__cta').remove();
        iamotaEventHandler.trigger('cartForm:items:item:undo:error', {
          error,
          item
        }, {
          context: _this
        });
      }).finally(() => {
        _this.setLoading(false);
      });
    })();
  }
  onDismiss(event) {
    event.preventDefault();
    var item = this.cartItem.itemData;
    iamotaEventHandler.trigger('cartForm:items:item:undo:dismissed', {
      item
    }, {
      context: this
    });
    this.remove(); // Remove self from the DOM
  }

  /**
   * Expose Loading/Disabled/Hidden state methods
   */
  setLoading(isLoading) {
    this.loadable.setLoading(isLoading);
  }
  isLoading() {
    return this.loadable.isLoading();
  }
}
customElements.define('iam-cart-undo-item', iamCartUndoItem);
export default iamCartUndoItem;